export class Constants {
  public static readonly HOME_ROUTE: string = '/';
  public static readonly LOGIN_ROUTE: string = '/login';
  public static readonly DASHBOARD_ROUTE: string = '/dashboard';
  public static readonly PREV_URL_KEY = 'PRV_URL';
  public static readonly USER_DATA: string = 'u';
  public static readonly NEW_LAUNCH_HOME: string = '/new-launches';
  public static readonly SUPPORT: string = '/support';
  public static readonly FOS_DATABSE: string = '/fos-visit/database';
  public static readonly PAYMENT: string = 'admin/payment';
  public static readonly REFERRAL: string = 'admin/referral';
  public static readonly SUBSCRIPTION: string = 'admin/subscription';
  public static readonly BROKERS_ACTIVITY: string = 'admin/brokers-activity';
  public static readonly USERS_SUPPORT: string = 'support/report';
  public static readonly FOS_VISIT: string = 'admin/fos-visit';
  public static readonly LOAN: string = 'admin/loan';
  public static readonly HELP_CENTER: string = '/help-center';
  // post inventory
  public static readonly POST_PROPERTY: string = 'post-property';
  public static readonly RESIDENTIAL: string = 'residential';
  public static readonly COMMERCIAL: string = 'commercial';
  public static readonly LAND_PLOT: string = 'land-plot';
  public static readonly RENT: string = 'rent';
  public static readonly SALE: string = 'sale';
  public static readonly PG_HOSTEL: string = 'pg-hostel';
  // =================

  // inventory listing
  public static readonly PROPERTY: string = 'property';
  public static readonly Broker_Profile: string = 'broker-profile';
}
